
<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import EntryDialog from '@/components/uicomp/ModalDialog-Form-Single'
const components = {
  EntryDialog,
}

/**
 * Static Data
 *
 */
const data = function () {
  return {
    opt: {},
    nlimitOptions: [
      { label: `10`, value: 10 },
      { label: `20`, value: 20 },
      { label: `50`, value: 50 },
      { label: `100`, value: 100 },
    ]
  }
}

/**
 * Computed
 *
 */
const computed = mapGetters({
  meta: `Product/TransactionReport/listMeta`,
  processing: `Product/TransactionReport/loadingState`,
  categoryOptions: `Product/Category/options`,
  supplierOptions: `Product/Supplier/options`,
})

/**
 * Methods
 *
 */
const methods = mapActions({
  setListOption: `Product/TransactionReport/setListOption`,
})

methods.reset = function() {
  this.opt = {
    pagelimit: this.meta.pagelimit,
    category: this.meta.filter.category,
    supplier: this.meta.filter.supplier,
  }
}

methods.dismiss = function() {
  this.$refs.EntryDialog.dismiss()
}

methods.show = function() {
  this.$refs.EntryDialog.show()
  this.reset()
}

methods.save = async function() {
  this.setListOption({
    pagelimit: this.opt.pagelimit,
    category: this.opt.category,
    supplier: this.opt.supplier,
  })
  this.dismiss()
}

/**
 * Watch
 *
 */
const watch = {
}

export default {
  components,
  data,
  computed,
  methods,
  watch,
}
</script>

<style scoped>
</style>

<template>
  <EntryDialog ref="EntryDialog" title="Table Setting" @submit="save">
    <FormGroup>
      <SelectField
        label="Record Per Page"
        :forceupper=true
        :options=nlimitOptions
        v-model="opt.pagelimit" />

      <SelectField
        label="Category"
        :forceupper=true
        :options=categoryOptions
        defaultValue=""
        defaultLabel="Semua Kategori"
        v-model="opt.category" />

      <SelectField
        label="Supplier"
        :forceupper=true
        :options=supplierOptions
        defaultValue=""
        defaultLabel="Semua Brand"
        v-model="opt.supplier" />
    </FormGroup>
  </EntryDialog>
</template>